import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const healthCheck = z.object({
  command: z.string().nullable(),
  execution: z
    .union([z.literal('now'), z.date().transform((date) => date.toISOString())])
    .optional(),
});

export class HealthCheck extends createZodDto(healthCheck) {}
